import { Tooltip } from "@mui/material";
import MDBox from "components/MDBox";
import React from "react";

function TemplateRound({ title, open, color, diameter = "24px" }) {
  return (
    <Tooltip title={title}>
      <MDBox
        sx={{
          width: diameter,
          height: diameter,
          borderRadius: "50%",
          background: open ? "transparent" : color,
          border: open && `4px solid ${color}`,
        }}
      />
    </Tooltip>
  );
}

export default TemplateRound;
